<section>
  <div class="row pt-3 mx-0">
    <div class="col-12 text-right">
      <button type="button" (click)="boxScan(order)" class="btn btn-orange btn-sm ml-2 mb-1">
        Scan Order
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="inner-box d-block d-sm-none">
        <table class="table tablesaw tablesaw-stack" data-tablesaw-mode="stack">
          <thead>
          <tr>
            <th>Order#</th>
            <th>Company Name</th>
            <th>Warehouse</th>
            <th width="200px;">Creation Date</th>
            <th width="150px;">Status</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let s of stockEntryList">
            <td><b class=" tablesaw-cell-label">Order#</b>
              <span class="tablesaw-cell-content"><a
                routerLink="/admin/stockReceiveView/{{s.stockEntryHeaderId}}">{{s.stockEntryNumber}}
                <img placement="bottom" ngbTooltip="Demo Order" class="ml-1 mb-1" src="assets/images/Demo.png"
                     width="20" height="20" *ngIf="s.accountType == 'DEMO_ACCOUNT'"></a>
            </span>
            </td>
            <td><b class=" tablesaw-cell-label">Company Name </b>
              <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{s.companyName}}</span>
            </td>
            <td><b class=" tablesaw-cell-label">Warehouse</b>
              <span class="tablesaw-cell-content" style="text-transform:capitalize;">{{s.warehouseName}}</span>
            </td>
            <td width="200px;"><b class=" tablesaw-cell-label">Creation Date</b>
              <span class="tablesaw-cell-content">{{s.inTransitDate}}</span>
            </td>
            <td width="150px;"><b class=" tablesaw-cell-label">Status</b>
              <span class="tablesaw-cell-content">{{(s.status == 'PARTIALLY_RECEIVED' ? 'Partially Received' :
                (s.status == 'IN_TRANSIT' ? 'In Transit' :
                  (s.status == 'RECEIVED' ? 'Received' : "")))}}</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
